(function (angular) {
    'use strict';

    angular
        .module('app.tos')
        .controller('app.tos.controller', [
            '$scope',
            '$http',
            tosController
        ]);

    function tosController($scope, $http) {
        $scope.tosHtml = '';
        $scope.wellfitPrivacyPolicy = environment.memberPortalUrl + siteContent.theme + '&showPrivacyPolicy=true';
        $scope.wellfitToS = environment.memberPortalUrl + siteContent.theme + '&showEula=true';
        var apiUrl = environment.treatmentApiDirectUrl + 'files/public-documents/terms-of-use.html';

        $http.get(apiUrl)
            .then(function (response) {
                $scope.tosHtml = response.data.replace('{{wellfitTermsOfUse}}', $scope.wellfitToS).replace('{{wellfitPrivacyPolicy}}', $scope.wellfitPrivacyPolicy);
            });
    }

})(angular);
